<template>
  <div class="choice-user-detail-item">
    <div
      class="div-block-102 applicant-card"
      v-if="clientInfo.id"
    >
      <div class="div-block-104 applicant-heading">
        <img
          src="https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f37_avatar%20cropped.png"
          loading="lazy"
          alt=""
          class="image-10"
        />
        <div class="div-block-103 aside">
          <div class="applicant-role">{{ clientInfo.type }}</div>
          <div class="bold pointer" v-if="clientInfo.id">
            <user-manager-handler :class-cst="'blc-color'" :client-info="client" :rules="['priority']" dti client detail/>
          </div>
        </div>
      </div>

      <div v-if="incomeRecalculating" role="status" class="income-recalculation-status">
        <v-progress-circular indeterminate :size="18" :width="2" /> Prepočítavam príjem a výšku hypotéky…
      </div>
      <div v-if="compact" class="applicant-summary" :aria-busy="String(incomeRecalculating)">
        <div class="applicant-metric">
          <div
            class="applicant-metric-label"
            title="Najvyšší mesačný príjem, ktorý niektorá z bánk akceptuje z evidovaných príjmov."
          >
            Akceptovaný príjem
          </div>
          <div v-if="incomeRecalculating" class="applicant-metric-value">Prepočítavam…</div>
          <div v-else class="applicant-metric-value positive">+{{ totalAcceptedMonthlyIncome | dotTheAmount }} EUR/mes.</div>
          <div class="applicant-metric-note">{{ activeIncomesLabel }} · najlepšia banka</div>
        </div>
        <div class="applicant-metric">
          <div
            class="applicant-metric-label"
            title="Mesačné splátky aktívnych záväzkov používané pri výpočte DSTI."
          >
            Splátky záväzkov
          </div>
          <div class="applicant-metric-value">{{ totalMonthlyDebtPayments | dotTheAmount }} EUR/mes.</div>
          <div class="applicant-metric-note">{{ activeDebtsLabel }}</div>
        </div>
        <div class="applicant-metric applicant-metric-total">
          <div
            class="applicant-metric-label"
            title="Orientačný maximálny úver podľa DTI. Nejde o mesačný príjem ani DSTI."
          >
            Orientačný DTI limit
          </div>
          <div v-if="incomeRecalculating" class="applicant-metric-value">Prepočítavam…</div>
          <div v-else class="applicant-metric-value">{{ totalDtiLimit | dotTheAmount }} EUR</div>
          <div class="applicant-metric-note applicant-metric-note--important">max. úver · nie mesačný príjem</div>
        </div>
      </div>

      <div v-show="!compact" class="applicant-detail-content">
      <div class="DTIitems">
        <div id="income-dti" class="input-block contrast p-relative" v-for="income in incomesGetter" :key="income.id" v-if="income.is_active">
          <div class="closebtn-broker-app pointer" @click="deactivateIncome(income.id)">
            <img class="nav-link-icon extrasmall white" src="https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f24_icons8-close.svg"/>
          </div>
          <div class="closebtn-broker-app pointer edit" @click="finishIncome(income)">
            <img class="nav-link-icon extrasmall white" src="https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/64cb50251cbbf5e263940bb6_edit%20icon%20simple.svg"/>
          </div>
          <div class="div-block-101">
            <div>
              <span v-if="income.zamestnavatel">
                {{ income.zamestnavatel.name }} ({{ translateIncomeType(income.druh) }})
              </span>
              <span v-else>
                {{ translateIncomeType(income.druh) }}
              </span>  
            </div>
            <v-progress-circular
              v-if="income.loading"
              class="loading-spinner extrasmall"
              indeterminate
            ></v-progress-circular>
            <div v-else class="income-dti-breakdown">
              <div class="bold positive">+{{ acceptedMonthlyIncome(income) | dotTheAmount }} EUR/mes.</div>
              <div class="applicant-metric-note">DTI limit {{ income.dti?.value | dotTheAmount }} EUR</div>
            </div>
          </div>
          <div class="div-block-112" v-if="income.error">
            <div class="text-cta pointer" @click="finishIncome(income)">
              DOKONČIŤ
            </div>
          </div>
        </div>
        <div class="input-block contrast p-relative" v-for="(debt, index) in debtsGetter" :key="debt.id" v-if="debt.mortgage_plan !== 'refinance'">
          <div class="closebtn-broker-app pointer" @click="deactivateDebt(debt.id)">
            <img class="nav-link-icon extrasmall white" src="https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f24_icons8-close.svg"/>
          </div>
          <div class="closebtn-broker-app pointer edit" @click="finishDebt(debt)">
            <img class="nav-link-icon extrasmall white" src="https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/64cb50251cbbf5e263940bb6_edit%20icon%20simple.svg"/>
          </div>
          <div id="debt-dti" class="div-block-101">
            <div>
              {{ translateDebtType(debt.typ) }} <strong>{{ translateBank(debt.banka) }}</strong> {{ debt.cislo_uveru ? "č." + debt.cislo_uveru : "" }}
            </div>
            <v-progress-circular
              v-if="debt.loading"
              class="loading-spinner extrasmall"
              indeterminate
            ></v-progress-circular>
            <div class="bold" v-else>
              <div v-if="debt.dti">{{ debt.dti?.value | dotTheAmount }} EUR</div>
              <div v-else>{{ debt.zostatok?.value | dotTheAmount }} EUR</div>
            </div>
            <div v-if="debt.error" class="text-cta pointer">
              DOPLNIŤ
            </div>
          </div>
          <div class="debt-activation-picker">
            <dropdown-select
              @select-to-from="changeActivationOfDebt($event, debt, index)"
              :first-time-prop="true"
              :id="'activation-picker' + debt.id"
              :init-value="debt.mortgage_plan === 'keep'"
              :options="activationPicker"
              :custom-css="'debt-activation-picker'"
              :value-correction="debtDtiActivationCorrection[index]"
              @value-corrected="debtDtiActivationCorrection.splice(index, 1, null)"
              dual-input
              normal
            />
          </div>
        </div>
      </div>
      <div
        class="DTIsummary"
        v-if="(debtsGetter.filter((d) => d.is_visible).length + incomesGetter.filter((d) => d.is_active).length) > 1"
      >
        celkom
        <span class="black">
          {{ totalDti | dotTheAmount }} EUR
        </span>
      </div>
      </div>
      <div class="client-actions">
        <client-personal-info-handler
          :client-info="personalInfo"
          :client-profile="client.client_profile"
          :rules="['priority']"
          :action-button="compact"
          :action-label="compact ? 'Bonita' : ''"
          mortgage-context
        />
        <client-income-handler
          :rules="['priority']"
          :client-info="clientInfo"
          :action-button="compact"
          :action-label="compact ? 'Príjmy' : ''"
        />
        <client-debt-handler
          :type="'classic'"
          :rules="['priority']"
          :title="compact ? 'Výdavky' : 'upraviť VÝDAVKY'"
          :client-info="clientInfo"
          :action-button="compact"
        />
        <div
          class="div-block-25 remove-coapplicant-action client-action-handler"
          v-if="clientInfo.type === 'Spolužiadateľ'"
        >
          <div
            class="add-prijem-btn client-action-button client-action-button--danger"
            @click="removeCoApplicant()"
          >
            <div class="text-small pointer client-action-label">
              Odobrať
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="coapplicant-empty-state" v-else>
      <client-add-handler
        :rules="['priority']"
        :client-info="clientInfo"
      />
    </div>
  </div>
</template>

<script>
import ClientDebtHandler from "../../../../shared/PopupHandler/Popups/ClientDebt/ClientDebtHandler";
import ClientIncomeHandler from "../../../../shared/PopupHandler/Popups/ClientIncomes/ClientIncomeHandler";
import ClientAddHandler from "../../../../shared/PopupHandler/Popups/ClientAdd/ClientAddHandler";
import UserManagerHandler from "../../../../shared/PopupHandler/Popups/UserManager/UserManagerHandler";
import translateFromDBValue from "../../../../../mixins/translateFromDBValue";
import ClientPersonalInfoHandler
  from "../../../../shared/PopupHandler/Popups/ClientPersonalInfo/ClientPersonalInfoHandler";
import DropdownSelect from "../../../../shared/DropdownSelect.vue";
import clientFilters from "../../../../../mixins/clientFilters";

export default {
  name: "ChoiceUserDetailItem",
  components: {
    ClientPersonalInfoHandler,
    DropdownSelect,
    UserManagerHandler, ClientAddHandler, ClientIncomeHandler, ClientDebtHandler
  },
  mixins: [
    translateFromDBValue,
    clientFilters
  ],
  props: {
    clientInfo: [Object, null],
    mortgageId: Number,
    client: [Object, null],
    coApplicant: Boolean,
    missingInformation: Boolean,
    compact: Boolean,
  },
  computed: {
    incomeRecalculating() { return (this.clientInfo.type_code === "coApplicant" && this.$store.getters["mortgageDetailState/getCoApplicantLoading"]) || this.incomesGetter.some(income => income.loading); },
    activeIncomesCount () {
      return this.incomesGetter.filter((income) => income.is_active).length;
    },
    visibleDebtsCount () {
      return this.debtsGetter.filter((debt) => debt.mortgage_plan !== "refinance").length;
    },
    activeDebtsCount () {
      return this.debtsGetter.filter((debt) => debt.mortgage_plan === "keep").length;
    },
    activeIncomesLabel () {
      return this.countLabel(this.activeIncomesCount, "aktívny príjem", "aktívne príjmy", "aktívnych príjmov");
    },
    activeDebtsLabel () {
      return this.countLabel(this.activeDebtsCount, "aktívny záväzok", "aktívne záväzky", "aktívnych záväzkov");
    },
    totalAcceptedMonthlyIncome () {
      return this.incomesGetter.reduce((total, income) => {
        if (!income.is_active) return total;
        return total + this.acceptedMonthlyIncome(income);
      }, 0);
    },
    totalMonthlyDebtPayments () {
      return this.debtsGetter.reduce((total, debt) => {
        if (debt.mortgage_plan !== "keep") return total;
        return total + this.monthlyDebtPayment(debt);
      }, 0);
    },
    totalIncomeDti () {
      return this.incomesGetter.reduce((total, income) => {
        if (!income.is_active) return total;
        return total + Number(income.dti?.value || 0);
      }, 0);
    },
    totalDebtDti () {
      return this.debtsGetter.reduce((total, debt) => {
        if (debt.mortgage_plan !== "keep") return total;
        return total + Number(debt.dti?.value || 0);
      }, 0);
    },
    totalDtiLimit () {
      return Math.max(0, this.totalIncomeDti + this.totalDebtDti);
    },
    personalInfo () {
      return {
        ...this.clientInfo,
        email: this.client.email,
        firstName: this.client.first_name,
        lastName: this.client.last_name,
      };
    },
    incomesGetter () {
      const incomes = this.$store.getters["mortgageDetailState/getClientIncomes"](this.clientInfo.type_code);
      this.incomeDtiInfo = incomes;
      return incomes;
    },
    debtsGetter () {
      const debts = this.$store.getters["mortgageDetailState/getClientDebts"](this.clientInfo.type_code, false);
      const currentDebts = debts.filter((debt) => debt.nahradeny_dlhom == null);
      this.debtDtiInfo = currentDebts;
      return currentDebts;
    }
  },
  data: () => ({
    debtDtiActivationCorrection: [],
    totalDti: 0,
    debtDtiInfo: [],
    incomeDtiInfo: [],
    activationPicker: [
      {
        display_name: "Splatím zo svojho",
        value: false,
      },
      {
        display_name: "Ponechávam si",
        value: true,
      },
      {
        display_name: "Refinancujem",
        value: "refinancovat",
      }
    ]
  }),
  async created () {
    this.calculateDti();
    this.debtDtiActivationCorrection = [];
    const debts = this.$store.getters["mortgageDetailState/getClientDebts"](this.clientInfo.type_code);
    for (const debt of debts) {
      this.debtDtiActivationCorrection.push(null);
    }
  },
  watch: {
    incomeDtiInfo () {
      this.calculateDti();
    },
    debtDtiInfo () {
      this.calculateDti();
    },
  },
  methods: {
    acceptedMonthlyIncome(income) {
      return Number(
        income?.dti?.extra?.prijem_mo
        ?? income?.dti?.prijem_mo
        ?? 0,
      ) || 0;
    },
    monthlyDebtPayment(debt) {
      return Math.abs(Number(
        debt?.dti?.extra?.mesacne_splatky
        ?? debt?.dti?.mesacne_splatky
        ?? 0,
      ) || 0);
    },
    countLabel(count, one, few, many) {
      if (count === 1) return `${count} ${one}`;
      if (count >= 2 && count <= 4) return `${count} ${few}`;
      return `${count} ${many}`;
    },
    getTotalAmount (amounts) {
      let totalAmount = 0;
      for (const amount of Object.values(amounts)) {
        totalAmount += amount;
      }
      return totalAmount;
    },
    lowerAmountsByOverflow(amountOverflow) {
      const amounts = this.$store.getters["mortgageDetailState/getAmounts"];
      if (amounts.suma_nadobudnutie >= amountOverflow) {
        const value = Math.round(Math.abs(amounts.suma_nadobudnutie - amountOverflow));
        return { amounts: {...amounts, suma_nadobudnutie: value},  label: `nadobudnutie na ${value}€` };
      }
      if ((amounts.suma_nadobudnutie + amounts.suma_bezucel) >= amountOverflow) {
        const value = Math.round(Math.abs(amounts.suma_bezucel + amounts.suma_nadobudnutie - amountOverflow));
        return {
          amounts: {
            ...amounts,
            suma_nadobudnutie: 0,
            suma_bezucel: value
          },
          label: `nadobudnutie na 0€ a bezúčel na ${value}€`
        }
      }
      if (this.getTotalAmount(amounts) >= amountOverflow) {
        const value = Math.round(Math.abs((amounts.suma_nadobudnutie + amounts.suma_bezucel + amounts.suma_refinancovanie) - amountOverflow));
        return {
          amounts: {
            suma_nadobudnutie: 0,
            suma_bezucel: 0,
            suma_refinancovanie: value
          },
          label: `nadobudnutie na 0€ bezúčel na 0€ refinancovanie na ${value}€`
        };
      }
      return false;
    },
    checkIfHasBudget (leftover, amounts) {
      const limit = this.$store.getters["mortgageDetailState/getLoanLimit"];
      const amount = this.getTotalAmount(amounts);
      const amountLeft = limit - amount;
      return {
        amountOverflow: Math.round(leftover-amountLeft),
        isBudgetEnough: leftover <= amountLeft
      };
    },
    showDialogToUser (label) {
      this.$store.commit("appState/setSuccessMessage", {
        text: label,
        type: "confirmation"
      });
    },
    constructMessageLabel(restOfLabel) {
      return "Pre refinancovanie dlhu bude potrebné nastaviť " + restOfLabel;
    },
    waitForUserPermission () {
      return new Promise((resolve) => {
        const int = setInterval(() => {
          const userConfirmation = this.$store.getters["appState/getUserConfirmation"];
          if (userConfirmation === true) {
            this.$store.commit("appState/setUserConfirmation", null);
            clearInterval(int);
            resolve(true);
          } else if (userConfirmation === false) {
            this.$store.commit("appState/setUserConfirmation", null);
            clearInterval(int);
            resolve(false);
          }
        }, 100);
      });
    },
    async setAsRefinanced(debt, index, from) {
      const amounts = this.$store.getters["mortgageDetailState/getAmounts"];
      const budgetData = this.checkIfHasBudget(debt.zostatok, amounts);
      if (!budgetData.isBudgetEnough) {
        if (from) {
          this.$store.commit("mortgageDetailState/setLimitCorrection", debt.dti?.value * -1);
        } else {
          const loweredAmountsObject = this.lowerAmountsByOverflow(budgetData.amountOverflow);
          this.showDialogToUser(this.constructMessageLabel(loweredAmountsObject.label));
          const userPermission = await this.waitForUserPermission();
          if (!userPermission) {
            this.debtDtiActivationCorrection.splice(index, 1, from);
            return;
          }
          this.$store.commit("mortgageDetailState/setAmounts", loweredAmountsObject.amounts);
        }
      }
      const clientObject = this.getClientType(debt.klient);
      const debtObject = {
        id: debt.id,
        plan: "refinance",
        clientRole: clientObject.type_code,
        clientLabel: clientObject.type,
      };
      console.log("Dispatching debtObject:", debtObject);

      this.$store.dispatch("mortgageDetailState/setMortgageDebtPlan", debtObject)
    },
    changeActivationOfDebt(active, debt, index) {
      if (active.to === "refinancovat") {
        this.setAsRefinanced(debt, index, active.from);
      } else {
        const data = {
          id: debt.id,
          clientLabel: this.clientInfo.type,
          clientRole: this.clientInfo.type_code,
          plan: active.to ? "keep" : "repay",
        };
        this.$store.dispatch("mortgageDetailState/setMortgageDebtPlan", data);
      }
    },
    finishIncome (income) {
      this.$store.commit("popupManagerState/setClientInfo", this.clientInfo);
      this.$store.commit("popupManagerState/pushToPopupOrder", {
        type: income.druh,
        payload: income,
        component: "ClientIncomePopUp",
        rules: null,
      });
    },
    finishDebt (debt) {
      this.$store.commit("popupManagerState/setClientInfo", this.clientInfo);
      this.$store.commit("popupManagerState/pushToPopupOrder", {
        type: {debtType: debt.typ, debtPurpose: "classic"},
        payload: debt,
        component: "ClientDebtPopUp",
        rules: null,
      });
    },
    async removeCoApplicant () {
      const mortgage = {
        id: parseInt(this.$route.params.hypoteka),
        object: {
          coapplicant: null,
          coapplicant_detail: null,
          pocet_spolocnych_nezaopatrenych_deti: 0,
        }
      };
      await this.$store.dispatch("mortgageDetailState/removeCoApplicant", mortgage);
    },
    navigateToKartaKlienti () {
      this.$router.push({name: "KartaKlienti"});
    },
    getIcon (type) {
      if (type === "Žiadateľ") {
        return require("@/images/avatar_applicant.png");
      } else if (type === "Spolužiadateľ") {
        return require("@/images/avatar_coapplicant.png");
      }
    },
    calculateDti () {
      let incomeDti = 0;
      let debtDti = 0;
      this.incomeDtiInfo.forEach((income) => {
        if (income.is_active) {
          incomeDti += income.dti?.value;
        }
      });
      this.debtDtiInfo.forEach((debt) => {
        if (debt.mortgage_plan === "keep") {
          debtDti += debt.dti?.value;
        }
      });
      this.totalDti = incomeDti + debtDti;
    },
    deactivateIncome (incomeId) {
      const data = {
        id: incomeId,
        clientLabel: this.clientInfo.type,
        clientRole: this.clientInfo.type_code,
        isActive: false,
      };
      this.$store.dispatch("mortgageDetailState/toggleClientIncome", data);
    },
    deactivateDebt (debtId) {
      const data = {
        id: debtId,
        clientLabel: this.clientInfo.type,
        clientRole: this.clientInfo.type_code,
        isActive: false,
      };
      this.$store.dispatch("mortgageDetailState/toggleClientDebt", data);
    },
  },
};
</script>

<style lang="scss" scoped>
.choice-user-detail-item,
.applicant-card {
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
}

.coapplicant-empty-state {
  display: flex;
  width: 100%;
  min-height: 100%;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.coapplicant-empty-state > * {
  display: flex;
  align-items: center;
  justify-content: center;
}

.applicant-card {
  height: 100%;
  margin-bottom: 0;
  padding: 16px 18px;
  border: 1px solid var(--app-border);
  border-radius: 14px;
  background: var(--app-surface);
  color: var(--app-text);
  box-shadow: var(--app-shadow);
}

.applicant-heading {
  min-width: 0;
  margin-bottom: 12px;
}

.applicant-heading .aside {
  min-width: 0;
  flex: 1 1 auto;
  align-items: flex-start;
  flex-direction: column;
}

.applicant-role {
  margin-bottom: 2px;
  color: var(--app-text-muted);
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
}

.applicant-summary {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
  width: 100%;
  margin-bottom: 12px;
}

.applicant-metric {
  box-sizing: border-box;
  min-width: 0;
  padding: 10px 12px;
  border-radius: 11px;
  border: 1px solid var(--app-border);
  background: var(--app-surface-muted);
}

.applicant-metric-total {
  background: var(--app-success-soft);
}

.applicant-metric-label,
.applicant-metric-note {
  overflow: hidden;
  color: var(--app-text-muted);
  font-size: 9px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.applicant-metric-value {
  overflow: hidden;
  margin: 3px 0;
  color: var(--app-text);
  font-size: 12px;
  font-weight: 900;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.applicant-metric-value.positive {
  color: var(--app-success);
}

.applicant-metric-note--important {
  color: var(--app-text);
  font-weight: 700;
}

.income-dti-breakdown {
  text-align: right;
}

.income-dti-breakdown .positive {
  color: var(--app-success);
}

.applicant-detail-content {
  width: 100%;
  min-width: 0;
}

.client-actions {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  width: 100%;
  align-items: center;
  gap: 8px;
}

.remove-coapplicant-action {
  grid-column: 1 / -1;
  width: auto;
  min-width: 92px;
  justify-self: end;
  height: auto;
}

.remove-coapplicant-action .client-action-button {
  width: auto;
  min-height: 30px;
  padding: 6px 12px;
  border-radius: 8px;
}


.closebtn-broker-app.pointer.edit{
  right:20px;
}

.wrapper{
  min-height: 0 !important;
}

@media screen and (max-width: 767px) {
  .applicant-summary {
    grid-template-columns: minmax(0, 1fr);
  }

  .client-actions {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

</style>

<style scoped>
.income-recalculation-status { display: flex; align-items: center; gap: 10px; padding: 12px 0; color: var(--app-primary, #60acff); font-size: 13px; }
</style>
